import { AbstractInteractorTool } from './tools';
import { RoomElementInteractors } from './interactors';
import { EditRoomElement } from './../cmd/EditRoomElement';
import { Util } from '../utils/Util';
export class MoveRoomElement extends AbstractInteractorTool {
    constructor(pRoomManager) {
        super(pRoomManager);
        this.mCommand = null;
        this.mDistanceFeedback = null;
    }
    initialize(pOpening) {
        this.mRoomElement = pOpening;
        this.mCommand = new EditRoomElement(this.mRoomManager, this.mRoomElement);
        this.mRoomManager.beginInteraction();
    }
    stop() {
        if (this.mCommand != null) {
            this.mCommand.cancel();
            this.mCommand = null;
        }
        this.mRoomManager.endInteraction();
        super.stop();
    }
    //// protected /////////////////////////////////////////////////////////////////////////////
    startPos(pPos) {
        //
    }
    updatePointerPosition(pPos) {
        let t2dPos = pPos;
        let tNearestWall = this.mRoomManager.getNearestWall(Util.to2d(t2dPos));
        if (tNearestWall == null)
            return;
        if (tNearestWall != this.mRoomElement.wall)
            this.mRoomElement.attachToWall(tNearestWall, Util.to2d(t2dPos));
        else
            this.mRoomElement.setPosition(t2dPos);
        this.mApp.rendering.notifyModelInteraction();
        if (this.mView != null)
            this.mView.viewer.requestRenderFrame();
    }
    finish() {
        if (this.mCommand == null)
            return;
        this.mApp.commands.executeCommand(this.mCommand).then(() => {
            this.mCommand = null;
            this.stop();
        });
    }
    prepareFeedback() {
        super.prepareFeedback();
        this.mDistanceFeedback = new RoomElementInteractors(this.mRoomManager, this.mRoomElement);
        this.mDistanceFeedback._updateDistInteractors();
    }
    clearFeedback() {
        super.clearFeedback();
        if (this.mDistanceFeedback != null) {
            this.mDistanceFeedback.clear();
            this.mDistanceFeedback = null;
        }
    }
    updateFeedback() {
        super.updateFeedback();
        if (this.mDistanceFeedback != null)
            this.mDistanceFeedback._updateDistInteractors();
    }
}
